import { useQuery } from '@tanstack/react-query';
import { EmployeeTimeOff } from '../../../types/EmployeeTimeOff';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchEmployeeTimeOff = async (uuid: string) => {
  const response = await CustomAxios.get<EmployeeTimeOff>(`employee_time_offs/${uuid}`);
  return response.data;
};

interface UseGetEmployeeTimeOffByIdProps {
  uuid: string;
  enabled?: boolean;
}

export function useGetEmployeeTimeOffById({ uuid, enabled = true }: UseGetEmployeeTimeOffByIdProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.allEmployeeTimeOffs, uuid],
    queryFn: () => fetchEmployeeTimeOff(uuid),
  });
}
